import { render, staticRenderFns } from "./PrincipalPedidos.vue?vue&type=template&id=dfcae1fe"
import script from "./PrincipalPedidos.vue?vue&type=script&lang=js"
export * from "./PrincipalPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports